var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLixo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 4.99996H14.4999H1.5H0.999892V3.00001H3.9999H11.9999H14.9999V4.99996ZM13.4999 17.9999C13.4999 18.5513 13.0513 18.9999 12.5 18.9999H3.49995C2.9485 18.9999 2.4999 18.5513 2.4999 17.9999V6.00002H4.50001V12.9999H5.49991V6.00002H7.50002V12.9999H8.49991V6.00002H10.4999V12.9999H11.4999V6.00002H13.4999L13.4999 17.9999ZM6.00002 0.999892H9.99992C10.5514 0.999892 11 1.44849 11 1.99995H4.99996C4.99996 1.44849 5.44856 0.999892 6.00002 0.999892ZM15.9999 1.99995H11.9999C11.9999 0.897196 11.1027 0 9.99992 0H6.00002C4.8971 0 3.9999 0.897196 3.9999 1.99995H0V6.00002H1.5V17.9999C1.5 19.1026 2.3972 20 3.49995 20H12.5C13.6027 20 14.4999 19.1026 14.4999 17.9999V6.00002H15.9999L15.9999 1.99995Z",
    fill: "#007BC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLixo);
export default __webpack_public_path__ + "static/media/lixo.f70775d0ffafcea25a9895cec1a7ffd2.svg";
export { ForwardRef as ReactComponent };